export default {
  resetPasswordEmail: "重设密码邮件",
  activeSuccess: "验证成功，正在跳转到登录页面",
  activingYourEmail: "正在验证你的邮件地址",
  addNewArticle: "投稿一篇回忆",
  allEvents: "全部主题活动",
  alreadyActived: "已经验证成功，正在跳转到登录页面",
  alreadyBeenTaken: "已经被占用了",
  alreadyRegistered: "这个邮件地址已经注册过时光之册了",
  back: "返回",
  backToHome: "返回主页",
  bookNeedPassword: "需要密码才能访问这个纪念册",
  bookSettings: "设置",
  cancel: "取消",
  changeAvatar: "修改头像",
  changePassword: "修改密码",
  clickToSignin: "点击这里直接登录",
  code: "链接",
  commentDeleted: "该评论已删除",
  createBookButton: "创建纪念册",
  createNewBook: "创建新纪念册",
  delete: "删除",
  deleteArticleConfirm: "确定将这篇文章删除吗？",
  deleteArticleMessage: "删除后将放入回收站，别人不再能看到",
  edit: "编辑",
  editArticleTitle: "编辑文章",
  editLink: "编辑分享链接",
  emailAddress: "邮件地址",
  emailNotFound: "这个邮件地址似乎从来没有注册过时光之册",
  emailRegisteredButNotActived: "验证邮件已发送至您的邮箱，等待验证",
  emailSendSuccess: "邮件发送成功",
  empty: "你忘了填写",
  eventList: "全部主题活动",
  eventListTitle: "正在进行的主题活动",
  favorite: "赞",
  fileMaxSizeExceed: "最大可以上传 {size} 的文件",
  fileNumberSizeExceed: "最多只能上传 {number} 个文件",
  uploadingFile: "还有文件正在上传中，请稍候",
  findPasswordButton: "重置密码",
  findPasswordTitle: "忘记密码",
  forgotPassword: "忘记密码？",
  Go: "Go",
  helloMessage: "Hi {email}, 开始之前，请先完善一下个人资料",
  ifActiveEmailNotReceived: "没收到验证邮件吗？",
  isAllowCoWrite: "允许投稿",
  isPublic: "是否公开",
  languageSelect: "语言",
  leaveComment: "留下你的评论",
  linkCopied: "链接已经复制到剪贴板",
  linkToInviteCollaborators: "分享链接",
  mailSendFailed: "邮件发送失败，请重试",
  mustWriteSth: "写点什么再发布吧",
  newArticle: "创建了",
  newComment: "评论了你的文章",
  newBook: "创建纪念册",
  noContent: "文章中没有内容",
  noNotice: "没有新的消息",
  noSuchUser: "用户不存在",
  notAllowSpecialCharacters: "不能包含特殊字符",
  nothingToView: "没找到你要看的东西",
  notification: "通知",
  okStart: "OK Let's start!",
  onlyAcceptFileType: "只能上传 {format} 格式的文件",
  pageNotFound: "你似乎输入了一个无效的连接, 这里什么都没有",
  pageNotFoundDesp: "",
  password: "密码",
  passwordCorrect: "密码验证成功，正在为你打开纪念册",
  passwordNotSame: "两次密码输入不一致",
  passwordProtection: "需要密码才能访问",
  passwordResetSuccess: "密码重置成功",
  postComment: "发布评论",
  publishArticle: "发布文章",
  randomPassword: "生成随机密码",
  resetPassword: "设置新密码",
  retry: "重试",
  saveArticle: "保存文章",
  saveAsDraft: "暂存",
  saveAvatar: "保存头像",
  saveBookChanges: "保存纪念册",
  saveFailed: "保存失败，请稍候重试",
  saveLink: "保存分享链接",
  saveUsername: "保存用户名",
  savePassword: "保存密码",
  saveSuccess: "保存成功",
  seeAllNotification: "全部消息",
  setBookPassword: "设置访问密码",
  setNewPasswordTitle: "设置新密码",
  setUsername: "设置用户名",
  settings: "账户",
  signin: "登录",
  signInTitle: "在这里登录",
  signInToSubmit: "登录后可参与创建，立刻登录",
  signup: "注册",
  signUpTitle: "在这里注册",
  signOut: "注销",
  submit: "提交",
  submitClosed: "投稿已被作者关闭",
  title: "标题",
  tooLong: "不能大于{len}位",
  tooShort: "不能小于{len}位",
  typeBookPasswordHere: "请输入访问密码",
  typeBookTitleHere: "在这里输入纪念册标题",
  typeEmailHere: "请输入邮件地址",
  typeNewCodeHere: "输入新的code",
  typePassword: "请输入密码",
  typePasswordHere: "在这里输入密码",
  typeValidEmail: "这似乎不是一个有效的邮件地址",
  unFavorite: "取消赞",
  unicapsule: "时光之册",
  updateProfile: "设置个人资料",
  uploadAvatar: "上传头像",
  uploadBookCover: "上传封面图片",
  uploadFailed: "上传失败，请稍候再试",
  views: "个查看",
  writeSthHere: "既然来了，留下些什么吧",
  wrongAccessCode: "密码错误",
  wrongPassword: "密码错误",
  zoomIn: "查看",
  typeNewBookPasswordHere: "输入新的访问密码",
  book: "纪念册",
  eventEndAt: "主题活动结束时间",
  comment: "评论",
  commentBeenDeleted: "你的评论已被删除",
  authing: "正在验证你的账户，请稍候",
  thirdPartyRegistered: "此邮件地址已经使用过 {provider} 注册过了",
  or: "或者",
  thirdPartyLogin: "使用 {provider} 直接登录",
  pleaseWait: "请稍候",
  repeatPasswordHere: "确认密码",
  newPasswordLogin: "密码重设成功，请使用新的密码登录",
  resetLinkExpired: "此链接已失效",
  avatar: "头像",
  username: "用户名",
  copyLink: "复制链接地址",
  createdBook: "创建的纪念册",
  joinedBook: "参与的纪念册",
  createdArticle: "创建的文章",
  favedBook: "赞过的纪念册",
  favedArticle: "赞过的文章",
  deleteCommentConfirm: "确定要删除这条评论吗",
  deleteCommentMessage: "删除后不可恢复",
  activeEmail: "验证邮件",
  emailSent: "已发送至你的邮箱",
  emailInstruction: "请按照邮件中的内容指示完成操作",
  emailSending: "正在发送，请稍候",
  clickHere: "点击这里",
  resendEmail: "重新发送",
  to: "  ",
  skipActivation: "邮件还没收到？先进去看看吧，以后有空再验证",
  activeEventList: "正在进行的主题活动",
  userNameDuplicated: "这名字不错，可惜已经被注册了。",
  networkError: "我们的服务器好像有故障了",
  serverCommunicateFaild:
    "在提交你的请求时服务器可能开了一点小差，为什么不等一等再试试呢",
  restPasswordInstruction1:
    "我们已给你发送了一封电子邮件，其中包含了重置密码的说明。",
  restPasswordInstruction2:
    "请确保它没有被过滤到你的垃圾邮件里。 如果你没有收到我们的密码重置邮件，请刷新页面后重试一次。",
  articleNotSaved: "刚才写的东西还没保存呢",
  articleNotSavedMessage: "不保存一下再退出吗？",
  discard: "不要了",
  refresh: "刷新页面",
  oldLinkVanished: "分享链接修改后，之前的链接将不能访问",
  hasNewBook: "{number} 个新纪念册",
  commentDeletedBy: "{name} 删除了你的评论",
  continueWithoutSign: "随便看看",
  typeValidLink: "这似乎不是一个有效的链接",
  link: "链接",
  insertLinkImgError: "下载该链接失败",
  getPostionFailed: "获取位置信息失败，请稍候再试",
  getWeatherFaild: "获取天气信息失败，请稍候再试",
  eventEndTip: "这个活动已经结束了，下次早点来吧",
  readMore: "继续阅读",
  widthOrigin: "原始宽度",
  rotateRight: "向右旋转",
  rotateLeft: "向左旋转",
  maxWidth: "宽度",
  fileReady: "等待上传",
  pintop: "置顶",
  cancelPintop: "取消置顶",
  mineHome: "个人主页",
  pullDownToRefresh: "下拉刷新数据",
  releaseToRefresh: "松开刷新数据",
  pullUpToLoad: "上拉加载数据",
  loadCompleted: "加载完毕",
  facebook: "facebook",
  weibo: "微博",
  wechatShare: "微信",
  emailShare: "邮件",
  openImage: "查看原图",
  draftArticle: "草稿",
  googleLoginFailed: "谷歌登录失败，请用email注册",
  advanceSetting: "高级设置",
  inviteFriends: "邀请好友参与",
  inviteFriendsPlaceholder: "输入好友邮件地址",
  invatationLetter: "邀请信",
  cardStyle: "卡片样式",
  typeBookIntroHere: "输入纪念册简介（可选）",
  activeEmailSendSuccess: "激活邮件已发送",
  canUpload: "VIP用户可上传{number}张图片",
  invatationLetterContent:
    "我在时光之册创建了一个纪念册,跟我一起纪念那些回忆吧",
  IndexPage: "首页",
  LoginPage: "登录",
  RegPage: "注册",
  CreatePage: "创建新的纪念册",
  EditBookPage: "修改纪念册",
  EventPage: "活动",
  EventViewPage: "活动详情",
  EventArticleListPage: "活动详情",
  BookViewPage: "查看纪念册",
  BookPage: "查看纪念册",
  AddArticlePage: "添加回忆",
  HomeDefaultPage: "个人主页",
  HomeCreatedBookPage: "我创建的纪念册",
  HomeFavedBookPage: "我赞过的纪念册",
  HomeJoinedBookPage: "我参与的纪念册",
  HomeCreatedArticlePage: "我创建的回忆",
  HomeFavedArticlePage: "我赞过的回忆",
  HomeDraftArticlePage: "我的草稿",
  SettingPage: "个人资料设置",
  ProfilePage: "个人资料设置",
  EmailActivationPage: "邮件激活",
  ActivationPage: "激活",
  ArticleViewPage: "查看回忆",
  ArticleViewByBookPage: "查看回忆",
  ArticleEditPage: "编辑回忆",
  ForgotPasswordPage: "忘记密码",
  ResetPasswordPage: "重设密码",
  AuthPage: "认证中",
  AuthCallbackPage: "认证中",
  "404Page": "没找到你要看的",
  notFoundPage: "没找到你要看的",
  invite: "邀请好友",
  sendInvite: "发出邀请",
  cannotInviteYouself: "不能邀请自己",
  invaiteSendSuccessed: "邀请发送成功",
  inviteSuccessed: "邀请已成功发出",
  inviteFailedEmail: "邮件地址无效",
  management: "内容管理",
  HomeCreatedBook: "创建的纪念册",
  HomeFavedBook: "赞过的纪念册",
  HomeJoinedBook: "参与过的纪念册",
  HomeCreatedArticle: "创建的回忆",
  HomeFavedArticle: "赞过的回忆",
  HomeDraftArticle: "草稿",
  privateBook: "查看加密的纪念册",
  downloadQrcode:"保存图片",
  eventMemberSum: '已投稿 {sum} 篇文章',
  eventCountdown:'距离活动结束还有',
  eventOpenDateCountdown:'距离公开内容还有',
  event:'主题活动',
  eventArticleList:'查看主题活动文章',
  addNewArticleToEvent:'投稿',
  EditEventPage:'编辑',
  saveEventChanges:'保存'
};
